import { render, staticRenderFns } from "./NotificationLogList.vue?vue&type=template&id=3e673220&scoped=true&"
import script from "./NotificationLogList.vue?vue&type=script&lang=js&"
export * from "./NotificationLogList.vue?vue&type=script&lang=js&"
import style0 from "./NotificationLogList.vue?vue&type=style&index=0&id=3e673220&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e673220",
  null
  
)

export default component.exports